var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.statusHeaders,"items":_vm.deviceStatuses,"options":_vm.deviceStatusesOptions,"server-items-length":_vm.totalDeviceStatuses,"items-per-page":5,"footer-props":{
    showFirstLastPage: true,
  }},on:{"update:options":function($event){_vm.deviceStatusesOptions=$event}},scopedSlots:_vm._u([{key:"item.lastConnected",fn:function(ref){
  var item = ref.item;
return [_c('div',[_vm._v(_vm._s(_vm.$format.dateTime(item.lastConnected)))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }